import React from 'react'

import { Alert, Portlet } from '_zari/core'

import * as AsientoContableService from 'services/asientosContables.service'

import AlertItem from './alertItem'

const LetrasPendientesSection = () => {
  const [letrasPendientes, setLetrasPendientes] = React.useState([])

  React.useEffect(() => {
    AsientoContableService.obtenerLetrasPendientesxSemana()
      .then(({ data }) => {
        if (data && data.length > 0) {
          setLetrasPendientes(data)
        } else {
          setLetrasPendientes([])
        }
      })
      .catch(() => {
        setLetrasPendientes([])
      })
  }, [])

  return (
    <Portlet>
      <Portlet.Header title='Letras pendientes por pagar de la semana' hideClose />
      <Portlet.Body>
        {letrasPendientes.length === 0 ? (
          <Alert color='info'>No hay letras pendientes para la semana.</Alert>
        ) : (
          letrasPendientes.map((x, k) => <AlertItem letraInfo={x} key={k} />)
        )}
      </Portlet.Body>
    </Portlet>
  )
}

export default React.memo(LetrasPendientesSection)
